import parse from 'html-react-parser';
import React, { useState, useEffect, useContext, useRef } from 'react';
import Loader from './Loader';
import { API_URL } from '../config';
import EventContext from '../contexts/EventContext';
import Layout from './Layout';
import { removeDuplicateObjectFromArray, sortByAttribute } from '../utils';
import useApiUrlTranslation from './useApiUrlTranslation';
import { Link } from 'react-router-dom';

import { useParams } from 'react-router-dom';
import { ClipboardDocumentCheckIcon, PaperAirplaneIcon, ClipboardIcon, LinkIcon } from '@heroicons/react/24/outline';
import { use } from 'i18next';

const DisplayContactCycleLang = ({ contactCycleLangList }) => {

    return (
        <div className="flex space-x-4">
            {contactCycleLangList && contactCycleLangList
                //dedup by contactCycleLang.cycle_lang.id_cycle_lang
                .filter((contactCycleLang, index, self) =>
                    index === self.findIndex((t) => (
                        t.cycle_lang.id_cycle_lang === contactCycleLang.cycle_lang.id_cycle_lang
                    ))
                )
                .map(contactCycleLang => <div className="">
                    <div className="hidden">
                        {contactCycleLang.cycle_lang.nom_cycle_lang}
                        {contactCycleLang.cycle_lang.id_cycle_lang}
                    </div>
                    <img src={contactCycleLang.cycle_lang.logo_better.large} className="w-32 rounded" alt="" />
                </div>)}
        </div>
    )
}


const Onboarding = ({ idFormulaireList, event, idContact }) => {

    const eventContext = useContext(EventContext);

    const { currentEvent } = eventContext;

    const [formulaireList, setFormulaireList] = useState(null);

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [contactConferencierList, setContactConferencierList] = useState(false);

    const [contactCycleLangList, setContactCycleLangList] = useState(false);

    const fetchContactCycleLang = async ({ idContact }) => {

        await fetch(`${apiUrlTranslation}?action=fetchContactCycleLang&filter= c.id_contact=${idContact} AND  contact_cycle_lang.id_cycle_lang !=0 AND  `)

            .then(res => res.json())
            .then(res => {
                setContactCycleLangList(res);
            })
    }

    const getFormulaireList = async () => {

        await fetch(`${apiUrlTranslation}?action=getFormulaireList&params= WHERE id_formulaire IN (${idFormulaireList.join(",")})`)
            .then(response => response.json())
            .then(data => {
                setFormulaireList(data);
            })
    }

    useEffect(() => {

        const getContactConferencierList = async ({ idContact }) => {

            await fetch(`${apiUrlTranslation}?action=getContactConferencierList&filter= AND id_event=${currentEvent.id_event}  AND cf.id_contact=${idContact}  AND cf.statut IN('coordinateur_geographique') GROUP BY cf.id_contact`)
                .then(res => res.json())
                .then(res => {
                    setContactConferencierList(res[0]);
                })
        }

        getContactConferencierList({ idContact });
        fetchContactCycleLang({ idContact });
        getFormulaireList();

    }, [i18n.resolvedLanguage, currentEvent, idContact])

    if (!event) return null;

    return <div>

        <div className="text-white mx-5 py-3 text-2xl font-bold">Phase 1 : Votre positionnement sur l'événement</div>

        {contactConferencierList && <div className='text-white mx-5 flex justify-between items-center space-x-5 my-5'>

            <div className="flex items-center space-x-5">
                <img src={contactConferencierList.contact.photos.large} alt="" className="rounded-full h-32" />

                <div className="">
                    <p className="text-xl font-bold mb-3"> {contactConferencierList.contact.prenom}  {contactConferencierList.contact.nom}</p>
                    <p>{contactConferencierList.contact.fonction} {contactConferencierList.contact.societe}</p>

                    {contactConferencierList.statut.libelle}
                </div>
            </div>

            <div>
                <DisplayContactCycleLang contactCycleLangList={contactCycleLangList} />
            </div>
        </div>}


        <div className="text-white mx-5 py-3 text-2xl font-bold">Phase 2 : Envoie des liens de participation à votre écosystème</div>

        <div className="bg-white mx-5 rounded-2xl py-4 p-5">

            <p className=" text-xl py-3 font-bold hidden">Send form</p>

            <div className="divide-y divide-neutral-400 text-sm">

                {formulaireList && formulaireList.map(formulaire => <div className="py-1 flex space-x-4  ">
                    <div className=" flex basis-9/12 items-center space-x-4">

                        <img src={formulaire.visuels.large} className="w-8   bg-black" />

                        <span> {formulaire.page_title}</span>
                    </div>

                    <div className="flex basis-3/12 space-x-3">
                        <a
                            target="_blank"
                            href={`/events/${event.id_event}/signup/${formulaire.route}/?form-name=${formulaire.route}&formisvisible=1&id_formulaire=${formulaire.id_formulaire}&lng=en&auteur=${idContact}`}
                            className="cursor-pointer flex ring-2  ring-pink-200 rounded-full text-xs px-4 py-2  hover:bg-pink-600 hover:text-white text-pink-700  space-x-2 items-center">
                            <LinkIcon className='w-4 ' /> Show form
                        </a>

                        <div className="hidden cursor-pointer flex bg-pink-200 rounded-full px-4 text-xs  py-2  hover:bg-pink-600 hover:text-white text-pink-700  space-x-2 items-center">
                            <PaperAirplaneIcon className='w-4 ' />
                            Send form
                        </div>
                    </div>
                </div>)}
            </div>
        </div>
    </div>
}


export default Onboarding;